import axios from "axios";
import EnvironmentService from "@/services/EnvironmentService";
import type { RMDFaqResponse } from "@/services/types/RMDFaqResponse";
import { rmdFaqs } from "@/store/rmd-faq.store";

class RMDFaqService {
    async loadFaqs(): Promise<void> {
        const response = await axios.get<RMDFaqResponse[]>(
            EnvironmentService.applicationConfiguration.bookingServiceBaseUrl + "ContentManager/RMDFAQs");
        rmdFaqs.cache = response.data;
    }
}

const rmdFaqService = new RMDFaqService();
const loadRMDFaqs = () => rmdFaqService.loadFaqs();

export { loadRMDFaqs };
